import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const ExperienceCard = makeShortcode("ExperienceCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Education`}</h2>
    <ExperienceCard title="Tarleton State University" years="August 2014 - May 2018" company="Bachelor of Science" bg="linear-gradient(to right, #04334B 40%, #BCBDBD 100%)" mdxType="ExperienceCard">
  Computer Science, Cum Laude
    </ExperienceCard>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      